var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#AD4D34"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7498 15.9989V23.0024C17.7848 23.269 17.6973 23.5534 17.496 23.7401C17.4151 23.8225 17.319 23.8878 17.2131 23.9324C17.1073 23.977 16.9938 24 16.8793 24C16.7647 24 16.6512 23.977 16.5454 23.9324C16.4395 23.8878 16.3434 23.8225 16.2625 23.7401L14.504 21.9537C14.4086 21.8589 14.3361 21.743 14.2921 21.615C14.2481 21.487 14.2337 21.3505 14.2502 21.216V15.9989H14.224L9.18469 9.4398C9.04262 9.25452 8.97851 9.01965 9.00638 8.7865C9.03425 8.55335 9.15183 8.34088 9.33342 8.19553C9.49965 8.0711 9.68337 8 9.87585 8H22.1242C22.3166 8 22.5003 8.0711 22.6666 8.19553C22.8482 8.34088 22.9657 8.55335 22.9936 8.7865C23.0215 9.01965 22.9574 9.25452 22.8153 9.4398L17.776 15.9989H17.7498Z",
    fill: "#FFFDF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.87595721ee71de59850be94970880b34.svg";
export { ForwardRef as ReactComponent };